import axios from 'axios'
import { Message } from 'element-ui'
import { cudaApiBase } from '@/utils/cudaOnLine'

const Mysql = axios.create({
  baseURL: cudaApiBase,
  timeout: 5000
})

// 添加请求拦截器
Mysql.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  Message.error('请求出错')
  return Promise.reject(error)
})

//  添加响应拦截器
Mysql.interceptors.response.use(response => {
  if (response.status && response.status !== 200) {
    console.error('response', response)
    throw new Error('服务错误')
  }

  return response.data
}, error => {
  const { response } = error
  if (response && response.status >= 400) {
    Message.error(`请求失败：${response.status} - ${response.statusText}`)
  } else if (!window.navigator.onLine) {
    Message({
      message: '网络已断开，请检查网络连接||或联系管理员检查!',
      duration: 5000,
      type: 'error'
    })
  } else if (error.code === 'ECONNABORTED') {
    Message({
      message: '请求超时，请稍后重试',
      duration: 5000,
      type: 'error'
    })
  } else {
    Message({
      message: '请求异常,请稍后再试||或联系管理员检查!',
      duration: 5000,
      type: 'error'
    })
  }
  return Promise.reject(error)
})

export default Mysql
